(() => {
  const DISCOUNT_TITLE = window.ykCartPromoBadge && window.ykCartPromoBadge.discountTitle;
  const NEW_PRICE_CLASS = 'yk-1gr-new-price';
  const STRIKE_CLASS = 'yk-1gr-strike';

  const formatMoney = (cents) => {
    if (typeof cents !== 'number' || Number.isNaN(cents)) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  };

  const getDiscountAmount = (item) => {
    if (!item || !Array.isArray(item.discounts)) return 0;
    return item.discounts
      .filter((discount) => discount && discount.title === DISCOUNT_TITLE)
      .reduce((sum, discount) => sum + (Number(discount.amount) || 0), 0);
  };

  const cleanupLine = (itemElement) => {
    const priceWrapper = itemElement.querySelector('.rebuy-cart__flyout-item-price');
    if (!priceWrapper) return;

    priceWrapper.querySelectorAll(`.${NEW_PRICE_CLASS}`).forEach((el) => el.remove());

    const saleSpan = priceWrapper.querySelector('.rebuy-money.sale');
    if (saleSpan) {
      saleSpan.classList.remove(STRIKE_CLASS);
    }
  };

  const applyPromoDisplay = () => {
    if (!window.Rebuy || !Rebuy.SmartCart?.cart?.items) return;

    Rebuy.SmartCart.cart.items.forEach((item) => {
      const itemElements = document.querySelectorAll(`.rebuy-cart__flyout-item[data-item-key="${item.key}"]`);
      itemElements.forEach((itemElement) => {
        cleanupLine(itemElement);

        const hasPromoDiscount =
          Array.isArray(item.discounts) && item.discounts.some((discount) => discount.title === DISCOUNT_TITLE);
        const badgePill = itemElement.querySelector('.yk-cart-collection-badge__discount-pill');
        const baseParagraph = itemElement.querySelector(
          '.yk-cart-collection-badge__paragraph:not(.yk-cart-collection-badge__paragraph--success)'
        );
        const successParagraph = itemElement.querySelector('.yk-cart-collection-badge__paragraph--success');
        itemElement.classList.toggle('yk-1gr-highlight', !!hasPromoDiscount);
        if (badgePill) {
          badgePill.style.display = hasPromoDiscount ? '' : 'none';
        }
        if (baseParagraph) {
          baseParagraph.style.display = hasPromoDiscount ? 'none' : '';
        }
        if (successParagraph) {
          successParagraph.style.display = hasPromoDiscount ? '' : 'none';
        }

        if (!hasPromoDiscount) return;

        const priceWrapper = itemElement.querySelector('.rebuy-cart__flyout-item-price');
        const priceContainer = priceWrapper?.querySelector('div') || priceWrapper;
        const saleSpan =
          priceContainer?.querySelector('.rebuy-money.sale') || priceContainer?.querySelector('.rebuy-money');
        if (!priceWrapper || !priceContainer || !saleSpan) return;

        const quantity = Number(item.quantity) || 1;
        const unitPrice = Number(item.price) || 0;
        const discountAmount = getDiscountAmount(item);
        const fullPrice = unitPrice * quantity;
        const discountedTotal = Math.max(fullPrice - discountAmount, 1);

        const newPriceEl = document.createElement('span');
        newPriceEl.className = NEW_PRICE_CLASS;
        newPriceEl.textContent = formatMoney(discountedTotal);

        saleSpan.textContent = formatMoney(fullPrice);
        saleSpan.classList.add(STRIKE_CLASS);

        priceContainer.insertBefore(newPriceEl, saleSpan);
      });
    });
  };

  const scheduleApply = () => {
    window.requestAnimationFrame(() => {
      setTimeout(applyPromoDisplay, 20);
    });
  };

  document.addEventListener('rebuy:cart.ready', scheduleApply);
  document.addEventListener('rebuy:cart.change', scheduleApply);
  document.addEventListener('rebuy:cart.enriched', scheduleApply);
  document.addEventListener('rebuy:smartcart.show', scheduleApply);
})();
